module.exports = {"fetching":true,"players":[],"nameFilter":"","ageFilter":"","positionFilter":""}


//////////////////
// WEBPACK FOOTER
// ./src/footballPlayers/constants/initialState.json
// module id = 100
// module chunks = 0